module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/callouts/applink-style1/applink-style1.component.scss
// module id = ./src/app/callouts/applink-style1/applink-style1.component.scss
// module chunks = main